<template>
  <div class="container customer-pool-task-container">
    <div class="customer-pool-task-container__content default-table">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="third">
          <el-badge slot="label" :value="statisticsMap.state_2">
            我的跟进
          </el-badge>
        </el-tab-pane>
        <el-tab-pane name="fourth">
          <el-badge slot="label" :value="statisticsMap.state_3">
            已成交
          </el-badge>
        </el-tab-pane>
        <el-tab-pane name="second">
          <el-badge slot="label" :value="statisticsMap.state_1">
            公海客户池
          </el-badge>
        </el-tab-pane>
      </el-tabs>
      <!--    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">-->
      <!--      <el-tab-pane :label="`我的跟进(${statisticsMap.state_2})`" name="third"></el-tab-pane>-->
      <!--      <el-tab-pane :label="`已成交(${statisticsMap.state_3})`" name="fourth"></el-tab-pane>-->
      <!--      <el-tab-pane :label="`公共客户池(${statisticsMap.state_1})`" name="second"></el-tab-pane>-->
      <!--      &lt;!&ndash;      <el-tab-pane :label="`公共客户池(${statisticsMap.all})`" name="first"></el-tab-pane>&ndash;&gt;-->
      <!--    </el-tabs>-->

      <div class="toolbar" style="display: flex;justify-content: space-between;align-items: center;">
        <div/>
        <toolbar-sort :fields="FieldsSort" @change="eventSort"/>
      </div>
      <el-table :data="dataList" height="calc(100% - 122px)" :show-header="false">
        <el-table-column width="350">
          <template
              v-slot="{row:{logo_name,pioneer_name,logo_f_size,sale_names},row}">
            <div style="display: flex;align-items: center;">
              <div class="logo" :style="{fontSize:logo_f_size}">
                {{ logo_name }}
              </div>
              <div style="margin-left: 20px;width: calc(100% - 96px);">
                <div style="color: #45474d;font-size: 15px;font-weight: bold;">
                  <customer-detail-link :customer="row" style="color: #45474d;font-size: 15px;font-weight: bold;"/>
                </div>
                <div>开拓销售：{{ pioneer_name || '-' }}</div>
                <div>历史销售：{{ sale_names }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{brand_name}}">
            <div v-if="brand_name" style="max-height: 100px;overflow-y: auto;"><b>品牌：</b>{{ brand_name }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template v-slot="{row}">
            <div style="display: flex;align-items: center;justify-content: center;">
              <div style="margin-right: 4px;">
                <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
                  {{ row.sales_volume|numberFormatW }}
                </div>
                <div style="color: #AAAAAA;">历史销售额</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center">
          <template v-slot="{row:{last_sales_volume}}">
            <div style="font-size: 16px;font-weight: 700;color: #45474d;margin-bottom: 4px;">
              {{ last_sales_volume|numberFormatW }}
            </div>
            <div style="color: #AAAAAA;">上一年销售额</div>
          </template>
        </el-table-column>
        <el-table-column>
          <template v-slot="{row:{created_at,bef_trade_at,assign_at,state}}">
            <div>加入时间
              <el-tooltip content="加入公海客户池时间">
                <i class="el-icon-info" style="color: #AAAAAA;cursor: pointer;"/>
              </el-tooltip>
              ：{{ created_at|parseTime }}
            </div>
            <div>最后下单
              <el-tooltip content="加入公海客户池前最后下单时间">
                <i class="el-icon-info" style="color: #AAAAAA;cursor: pointer;"/>
              </el-tooltip>
              ：{{ bef_trade_at|parseTime }}
            </div>
            <div v-if="assign_at">分配/领取：{{ assign_at|parseTime }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="activeName!=='second'">
          <template v-slot="{row:{sale_name,follow_record,aft_trade_at}}">
            <div>跟进销售：{{ sale_name }}</div>
            <div>跟进记录：{{ follow_record || '暂无' }}</div>
            <div>成交时间：<span v-if="aft_trade_at">{{
                aft_trade_at |parseTime
              }}</span><span v-else>暂无</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" fixed="right">
          <template slot-scope="{row}">
            <el-link type="primary" icon="el-icon-plus" title="添加跟进记录" @click="handleTaskRecord(row)"
                     v-show="showAppendRecord" v-if="permissions.indexOf('customer_pool_task_record_add')>-1">跟进
            </el-link> &nbsp;&nbsp;
            <el-link type="primary" icon="el-icon-refresh-left" title="放弃跟进:返回公共池" @click="resetSale(row)"
                     v-show="showResetBtn"
                     v-if="activeName==='third'&& permissions.indexOf('customer_pool_task_reset')>-1">放弃
            </el-link> &nbsp;&nbsp;
            <el-link type="primary" icon="el-icon-s-claim" @click="handleClaim(row)"
                     v-if="activeName==='second'&& permissions.indexOf('customer_pool_task_claim')>-1">
              领取
            </el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div>
        <Pagination
            v-show="total>0"
            :total="total"
            :page.sync="query.page"
            :limit.sync="query.per_page"
            @pagination="handleQuery"
            :page-sizes="[3,5,10,15]"
        />
      </div>
      <!--    新增和修改记录-->
      <AddTaskRecord :visible.sync="openDialog" :id="currentId" @close="init"/>
    </div>
  </div>
</template>

<script>
import {
  customerRecordDel, customerRecordSetSale,
  getCustomerRecordList, getCustomerRecordReset,
  getCustomerRecordStatisticsTask
} from "../../api/customerPool";
import AddTaskRecord from "./AddTaskRecord";
import {lsGet} from "../../utils";
import CustomerDetailLink from "../custom/components/detail-link.vue";
import {CodeToText} from 'element-china-area-data'
import ToolbarSort from "../../components/ToolbarSort/index.vue";

const area = Object.values(CodeToText).map((_ => {
  let tmp
  tmp = _.replace(/省/g, "")
  tmp = tmp.replace(/市/g, "")
  tmp = tmp.replace(/区/g, "")
  return tmp
}))

function getStrLenShort(name) {
  const array = [/信息技术有限公司/g, /美妆有限公司/g, /传媒有限公司/g, /科技有限公司/g, /有限公司/g]
  array.forEach(item => {
    name = name.replace(item, "")
  })
  if (name.length > 8) {
    name = name.substring(0, 8)
  }
  return name
}

const FieldsSort = [
  {label: '历史销售额', field: 'sales_volume'},
  {label: '上一年销售额', field: 'last_sales_volume'},
  {label: '最后下单时间', field: 'bef_trade_at'},
  {label: '分配时间', field: 'assign_at'},
]

export default {
  name: "CustomerPoolTask",
  components: {ToolbarSort, CustomerDetailLink, AddTaskRecord},
  data() {
    return {
      FieldsSort,
      activeName: 'third',
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      query: {page: 1, per_page: 15, state: 2, sale_id: null, orderBy: "`id` desc"},
      orderSort: {id: 'desc'},
      dataList: [
        {customer_id: '', customer_name: '客户1'}
      ],
      openDialog: false,
      currentId: null,
      statisticsMap: {all: 0, state_1: 0, state_2: 0, state_3: 0},
      openDialogSale: false,//更换销售弹窗
      loginUser: {}//当前登录者信息
    }
  },
  computed: {
    permissions() {
      return this.$store.getters.userPermissions;
    },
    showAppendRecord() {
      return ['third', 'fourth'].indexOf(this.activeName) > -1
    },
    showResetBtn() {
      return ['third'].indexOf(this.activeName) > -1
    },
    showSelection() {
      return ['third'].indexOf(this.activeName) > -1
    },
    user() {
      return this.$store.getters.getUser
    },
  },
  methods: {
    init() {
      this.getStatistics()
      this.handleQuery()
    },
    // eslint-disable-next-line no-unused-vars
    handleClick(tab, event) {
      switch (this.activeName) {
        case 'first':
          this.query.state = null;
          this.query.sale_id = null
          break;
        case 'second':
          this.query.state = 1;
          this.query.sale_id = null
          break;
        case 'third':
          this.query.state = 2;
          this.query.sale_id = this.loginUser.id
          break;
        case 'fourth':
          this.query.state = 3;
          this.query.sale_id = this.loginUser.id
          break;
        default:
          this.query.state = null;
          break;
      }
      this.query.page = 1
      this.handleQuery()
    },
    eventSort: function (field, sort) {
      this.query.orderBy = field ? `${field} ${sort}` : ''
      this.query.page = 1
      this.handleQuery()
    },
    handleQuery() {
      this.loading = true
      this.dataList = []
      if (['third', 'fourth'].indexOf(this.activeName) > -1 && !this.query.sale_id) {
        this.$notify.warning('我的跟进任务查询失败，请【重新登录】或【联系管理员】')
        return
      }
      getCustomerRecordList(this.query).then(res => {
        const data = res.data || {}
        let table = data.list || []
        table.map(_ => {
          _.logo_name = this.getShortName(_.customer_name)
          _.logo_f_size = '20px'
          switch (_.logo_name.length) {
            case 4:
              _.logo_f_size = '26px'
              break;
            case 5:
              _.logo_f_size = '20px'
              break;
            case 6:
              _.logo_f_size = '20px'
              break;
            case 7:
            case 8:
            case 9:
            case 10:
              _.logo_f_size = '17px'
              break;
          }
        })
        this.dataList = table
        this.query.page = data.current_page
        this.query.per_page = data.per_page
        this.total = data.total || 0
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    handleAdd() {
      this.currentId = null
      this.openDialog = true
    },
    handleEdit(id) {
      this.currentId = id
      this.openDialog = true
    },
    changeTableSort({prop, order}) {
      this.query.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.handleQuery()
    },
    handleDel(row) {
      const ids = row.id || this.ids;
      this.$msgbox.confirm('是否确认删除编号为"' + ids + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调用删除方法
        customerRecordDel({ids: ids}).then((res) => {
          const data = res.data || {}
          if (data.id) {
            this.$message.success(res.message || '删除操作')
          }
        })
      }).then(() => {
        this.init();
        // this.msgSuccess("删除成功");
      }).catch(function (e) {
        // eslint-disable-next-line no-console
        console.log('e', e)
      });

    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    //统计
    getStatistics() {
      getCustomerRecordStatisticsTask().then(res => {
        let data = res.data || {}
        let list = data.list || []
        let stateOneTotal = data.total;//待分配（公共池）
        let map = {}
        if (list.length > 0) {
          list.map((item) => {
            map[`state_${item.state}`] = item.total || 0
          })
          // map['all'] = total
          //
          // this.statisticsMap.all = map.all || 0
          // this.statisticsMap.state_1 = map.state_1 || 0
          //【我的跟进】
          this.statisticsMap.state_2 = map.state_2 || 0
          //【已成交】
          this.statisticsMap.state_3 = map.state_3 || 0
        }
        this.statisticsMap.state_1 = stateOneTotal || 0
      })
    },
    resetSale(row) {
      //
      let ids = row.id ? [row.id] : this.ids
      let msg = ''
      if (row.id) {
        msg = `确认【放弃跟进】客户【${row.customer_name}】吗？放弃后该客户将返回公海`
      } else {
        msg = '是否确认将勾选的【' + ids.length + '】个客户数据返回公共池，操作成功后可以重新分配销售?'
      }
      this.$msgbox.confirm(msg, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //调用删除方法
        getCustomerRecordReset({ids: ids}).then(res => {
          this.msgSuccess(res.message || '操作成功')
          this.init()
        })
        ;
      });

    },
    handleClaim: function (row) {
      let data = {ids: [row.id], sale_id: this.user.id, sale_name: this.user.name, is_notify: true}
      this.$msgbox.confirm(`确认跟进【${row.customer_name}】客户吗？`, "领取", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        customerRecordSetSale(data).then(({success, message}) => {
          if (!success) {
            this.$message.error(message || '操作失败')
            return
          }
          this.msgSuccess('领取成功')
          this.init()
        })
      });
    },
    handleTaskRecord(row) {
      //添加跟进记录
      this.currentId = row.id
      this.openDialog = true
    },
    getShortName: function (name) {
      for (let i = 0; i < area.length; i++) {
        let prefix = area[i]
        if (name.startsWith(prefix)) {
          name = name.substring(prefix.length)
        }
      }
      return getStrLenShort(name)
    },
  },
  mounted() {
    let userInfo = lsGet('user')
    this.loginUser = userInfo || {}
    this.query.sale_id = this.loginUser.id
    this.init()
  }
}
</script>

<style scoped>
.title {
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 10px;
}

.title:hover {
  font-size: 2.1em;

}

.op-row {
  padding: 10px;
}

</style>

<style lang="scss">
.customer-pool-task-container {
  font-family: FjallaOne-Regular, sans-serif !important;
  padding: 24px;
  background: #F5F6FA;
  height: calc(100vh - 64px - 48px);

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .el-form {
    //border-radius: 8px;
    //background: #FFFFFF;
    //margin-bottom: 12px;
    //padding: 18px 18px 10px 18px;
  }

  .el-form-item--mini.el-form-item {
    margin-bottom: 8px !important;
  }

  &__content {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 12px 30px 24px 30px;
    position: relative;
    height: calc(100% - 36px);
  }

  .el-pagination {
  }

  .default-table tr.el-table__row .cell {
    height: unset !important;
    line-height: unset !important;

  }

  .el-icon-notebook-2, .el-icon-connection, .el-icon-coin {
    color: #fe346e;
    margin-right: 4px;
    font-size: 14px;
    font-weight: 600;
  }

  .logo {
    font-family: FjallaOne-Regular, sans-serif !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 600;
    width: 76px;
    height: 76px;
    background: #ffeef3;
    color: #fe346e;
    line-height: 1.2;
  }

  .ellipsis {
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
  }

  .el-table td, .el-table th {
    padding: 14px 0 !important;
  }

  .el-table__row {
    cursor: pointer;
  }

  .edit-aim {
    opacity: 0;
    width: 30px;
    height: 30px;
  }

  .el-table__row:hover {
    .edit-aim {
      opacity: 1;
    }
  }

  .toolbar {
    padding-bottom: 12px;
    border-bottom: 1px solid #F2F2F2;
  }

  .el-badge__content.is-fixed {
    top: 15px !important;
    right: 5px;
  }
}
</style>
